import { connect } from 'react-redux';
import { foundAddress, hasFoundAddress } from 'redux/modules/address-suggestion/selectors';
import { onSubmitAddAddress as onSubmit, addressApiError } from 'redux/modules/address/actions';
import {
  getAddresseeFormValues,
  addAddressLoadingSelector,
  getAddressInError,
} from 'redux/modules/address/selectors';
import { getFeatureFlags as getFeatures } from 'utils/feature-flags';
import { formatContactNumber } from '../util';
import AddAddress from './AddAddress';

const form = 'Forms.Address.AddAddress';

const mapStateToProps = (state, { initialValues, onAfterSubmit, manualOnly = true }) => {
  const existingValues = getAddresseeFormValues(state, form);
  const addressInError = getAddressInError(state);

  const mappedProps = {
    editMode: existingValues && Object.keys(existingValues).length > 0,
    hasFoundAddress: hasFoundAddress(state),
    initialValues: {
      ...initialValues,
      country: 'GB',
    },
    foundAddressValues: foundAddress(state),
    loading: addAddressLoadingSelector(state),
    loadingMessage: 'Saving your address',
    hasError: addressInError !== null,
    manualOnly,
    onAfterSubmit,
  };

  if (!getFeatures(state).manualAddressFormOnly) {
    return { ...mappedProps, manualOnly: false };
  }

  return mappedProps;
};

const mapDispatchToProps = (dispatch, props) => {
  const onError = (error, address) => {
    if (error && error.status) {
      dispatch(addressApiError(address));
      return { hasError: true };
    }
    throw error;
  };
  return {
    onSubmit: address => {
      const addressWithFormattedContactNumber = {
        ...address,
        contactNumber: formatContactNumber(address.contactNumber),
      };

      return props.onSubmit
        ? props
            .onSubmit(addressWithFormattedContactNumber)
            .then(value => props.onAfterSubmit(value))
            .catch(error => onError(error, addressWithFormattedContactNumber))
        : dispatch(onSubmit(addressWithFormattedContactNumber))
            .then(value => props.onAfterSubmit(value))
            .catch(error => onError(error, addressWithFormattedContactNumber));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAddress);
